import { FC, PropsWithChildren, Suspense } from 'react';
import { FeatureFlagsContext, useFeatureFlags } from 'common-services/feature-flags/feature-flags-hook';

export interface IAppWrapper {
  flags: FeatureNames;
}

const AppWrapper: FC<PropsWithChildren<IAppWrapper>> = (props) => {
  return (
    <FeatureFlagsContext.Provider value={useFeatureFlags(props?.flags)}>
      <Suspense fallback={<></>}>{props.children}</Suspense>
    </FeatureFlagsContext.Provider>
  );
};

export default AppWrapper;
